/* Velour — katalóg: dropdown filtre (Značka/Typ vône), size-selector a add-to-cart
   nad server-side vykresleným gridom (collection.liquid). Filtrovanie je čisto
   klientske (show/hide cez triedu .hidden), rovnako ako na pôvodnom statickom webe.

   Filtre sú VIACNÁSOBNÉ, ale každý má inú logiku, lebo iné sú aj dáta:

     Značka = ALEBO. Vôňa má práve jednu značku, takže "Byredo a zároveň
     Dior" by nevrátilo nikdy nič. Byredo + Dior = ukáž oboje.

     Typ vône = A ZÁROVEŇ. Vôňa má typov viac, takže "sladká a zároveň
     korenistá" dáva zmysel a je to aj to, čo zákazník od dvoch zaškrtnutých
     typov čaká. Vďaka tomu sa nemožné kombinácie (drevitá + citrusová —
     taká vôňa v katalógu nie je) samy zošednú a nedajú sa zvoliť.

   Pri každej možnosti je počet vôní, ktoré by po jej zvolení zostali, takže
   sa nedá naklikať prázdny výsledok. Stav sa zrkadlí do URL
   (?znacka=…&typ=…), aby sa dal poslať odkaz na konkrétny výber. */
(function () {
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function () { entry.target.classList.add('visible'); }, i * 40);
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });

  /* Vybraté hodnoty. V rámci filtra platí ALEBO, medzi filtrami A ZÁROVEŇ.
     Prázdne pole = filter neaktívny (teda "všetky"). */
  var selected = { brand: [], type: [] };
  var cards = [];

  var URL_KEY = { brand: 'znacka', type: 'typ' };
  // 'or'  = stačí jedna zo zvolených hodnôt (značka — vôňa ich má vždy jednu)
  // 'and' = vôňa musí spĺňať všetky zvolené (typ — vôňa ich má viac)
  var MODE = { brand: 'or', type: 'and' };

  function panelOf(kind) {
    return document.getElementById(kind === 'brand' ? 'brandDDPanel' : 'typeDDPanel');
  }

  function toggle(kind, value) {
    var i = selected[kind].indexOf(value);
    if (i === -1) selected[kind].push(value); else selected[kind].splice(i, 1);
  }

  /* Slovenské skloňovanie — 1 vôňa, 2-4 vône, 5+ vôní. */
  function fragranceWord(n) {
    if (n === 1) return 'vôňa';
    if (n >= 2 && n <= 4) return 'vône';
    return 'vôní';
  }

  function matches(card, kind, values) {
    if (!values.length) return true;
    if (kind === 'brand') return values.indexOf(card.dataset.vendor) !== -1;
    var types = (card.dataset.types || '').split(' ');
    return values.every(function (v) { return types.indexOf(v) !== -1; });
  }

  /* Ako by výber v danom filtri vyzeral, keby zákazník klikol na `value`.
     Pri 'and' treba počítať s celým doterajším výberom naraz — inak by
     "drevitá + citrusová" ukazovala počet citrusových a tvárila sa, že
     sa dá zvoliť, hoci spolu nedajú ani jednu vôňu. */
  function hypothetical(kind, value) {
    if (MODE[kind] === 'or') return [value];
    if (selected[kind].indexOf(value) !== -1) return selected[kind];
    return selected[kind].concat([value]);
  }

  function closeDropdowns() {
    document.querySelectorAll('.filter-dd.open').forEach(function (dd) {
      dd.classList.remove('open');
      dd.querySelector('.filter-dd-btn').setAttribute('aria-expanded', 'false');
    });
  }

  function syncUrl() {
    var params = new URLSearchParams(window.location.search);
    ['brand', 'type'].forEach(function (kind) {
      if (selected[kind].length) params.set(URL_KEY[kind], selected[kind].join(','));
      else params.delete(URL_KEY[kind]);
    });
    var qs = params.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  }

  function readUrl() {
    var params = new URLSearchParams(window.location.search);
    ['brand', 'type'].forEach(function (kind) {
      var raw = params.get(URL_KEY[kind]);
      if (!raw) return;
      var valid = [];
      panelOf(kind).querySelectorAll('.filter-dd-option').forEach(function (o) { valid.push(o.dataset.value); });
      // neznáme hodnoty z URL ticho zahodíme, nech sa filter nezasekne
      var wanted = raw.split(',').filter(function (v) { return valid.indexOf(v) !== -1; });

      if (MODE[kind] === 'or') { selected[kind] = wanted; return; }

      /* Pri 'and' sa ručne upravená URL (?typ=woody,fresh) vie dostať tam,
         kam sa klikaním nedá — na prázdny výsledok. Skladáme preto po jednej
         a hodnotu, ktorá by výsledok vynulovala, zahodíme. */
      var other = kind === 'brand' ? 'type' : 'brand';
      var acc = [];
      wanted.forEach(function (v) {
        var probe = acc.concat([v]);
        var hits = cards.filter(function (c) {
          return matches(c, other, selected[other]) && matches(c, kind, probe);
        }).length;
        if (hits > 0) acc = probe;
      });
      selected[kind] = acc;
    });
  }

  function renderChips() {
    var wrap = document.getElementById('filterChips');
    if (!wrap) return;
    var html = '';
    ['brand', 'type'].forEach(function (kind) {
      selected[kind].forEach(function (value) {
        var opt = panelOf(kind).querySelector('.filter-dd-option[data-value="' + value + '"]');
        if (!opt) return;
        html += '<button class="filter-chip" type="button" data-kind="' + kind + '" data-value="' + value + '" ' +
                'aria-label="Zrušiť filter ' + opt.dataset.label + '">' +
                opt.dataset.label + '<span class="filter-chip-x" aria-hidden="true">&#10005;</span></button>';
      });
    });
    wrap.innerHTML = html;
    wrap.hidden = html === '';
  }

  /* Počty pri možnostiach sa rátajú proti DRUHÉMU filtru, nie proti sebe —
     inak by po označení jednej značky všetky ostatné ukazovali nulu. */
  function renderOptions() {
    ['brand', 'type'].forEach(function (kind) {
      var other = kind === 'brand' ? 'type' : 'brand';
      var pool = cards.filter(function (c) { return matches(c, other, selected[other]); });

      panelOf(kind).querySelectorAll('.filter-dd-option').forEach(function (opt) {
        var value = opt.dataset.value;
        var isOn = selected[kind].indexOf(value) !== -1;
        var probe = hypothetical(kind, value);
        var count = pool.filter(function (c) { return matches(c, kind, probe); }).length;

        opt.classList.toggle('selected', isOn);
        opt.setAttribute('aria-selected', isOn ? 'true' : 'false');
        opt.querySelector('.filter-dd-count').textContent = count;
        // možnosť bez výsledkov sa nedá zvoliť, ale odznačiť sa dá vždy
        opt.classList.toggle('is-empty', count === 0 && !isOn);
        opt.disabled = count === 0 && !isOn;
      });

      var n = selected[kind].length;
      var label = 'Všetky';
      if (n === 1) {
        var one = panelOf(kind).querySelector('.filter-dd-option[data-value="' + selected[kind][0] + '"]');
        label = one ? one.dataset.label : 'Všetky';
      } else if (n > 1) {
        label = n + (n <= 4 ? ' vybraté' : ' vybratých');
      }
      document.getElementById(kind + 'DDLabel').textContent = label;
      document.getElementById(kind + 'DDBtn').classList.toggle('filtered', n > 0);
    });
  }

  function applyFilters() {
    var visible = 0;
    cards.forEach(function (card) {
      var show = matches(card, 'brand', selected.brand) && matches(card, 'type', selected.type);
      card.classList.toggle('hidden', !show);
      if (show) visible++;
    });

    var noResults = document.getElementById('no-results');
    if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';

    var active = selected.brand.length + selected.type.length;
    var reset = document.getElementById('filterReset');
    if (reset) reset.hidden = active === 0;

    var count = document.getElementById('catalogCount');
    if (count) count.textContent = active === 0 ? '' : visible + ' ' + fragranceWord(visible);

    renderOptions();
    renderChips();
    syncUrl();
  }

  function resetFilters() {
    selected.brand = [];
    selected.type = [];
    applyFilters();
  }

  function initFilterDropdowns() {
    [['brandDD', 'brandDDBtn'], ['typeDD', 'typeDDBtn']].forEach(function (pair) {
      var dd = document.getElementById(pair[0]);
      var btnEl = document.getElementById(pair[1]);
      if (!dd || !btnEl) return;
      btnEl.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = dd.classList.contains('open');
        closeDropdowns();
        if (!wasOpen) {
          dd.classList.add('open');
          btnEl.setAttribute('aria-expanded', 'true');
        }
      });
      // klik v paneli nesmie panel zavrieť — inak sa nedá vybrať viac naraz
      dd.querySelector('.filter-dd-panel').addEventListener('click', function (e) { e.stopPropagation(); });
    });

    document.querySelectorAll('.filter-dd-option').forEach(function (opt) {
      var kind = opt.closest('#brandDD') ? 'brand' : 'type';
      opt.addEventListener('click', function () {
        toggle(kind, opt.dataset.value);
        applyFilters();
      });
    });

    document.querySelectorAll('.filter-dd-all').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selected[btn.dataset.clear] = [];
        applyFilters();
      });
    });

    var chips = document.getElementById('filterChips');
    if (chips) chips.addEventListener('click', function (e) {
      var chip = e.target.closest('.filter-chip');
      if (!chip) return;
      toggle(chip.dataset.kind, chip.dataset.value);
      applyFilters();
    });

    document.addEventListener('click', closeDropdowns);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdowns();
    });

    var resetBtn = document.getElementById('filterReset');
    if (resetBtn) resetBtn.addEventListener('click', resetFilters);
  }

  function initSizeSelectors() {
    document.querySelectorAll('.size-selector').forEach(function (selector) {
      // poznámka o 2 ml flakóne je súrodenec selektora, nie jeho dieťa
      var scope = selector.parentNode;
      selector.querySelectorAll('.size-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selector.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          window.VELOUR.syncVialNote(scope);
        });
      });
      window.VELOUR.syncVialNote(scope);
    });
  }

  function initCardLinks() {
    document.querySelectorAll('.product-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('button') || e.target.closest('a')) return;
        var url = card.dataset.url;
        if (url) window.location.href = url;
      });
    });
  }

  function initAddToCart() {
    document.querySelectorAll('.add-to-cart-btn:not(.set-add-btn)').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.product-card');
        var selectedSize = card.querySelector('.size-btn.selected');
        if (!selectedSize) return;
        var variantId = selectedSize.dataset.variantId;
        window.VELOUR.cartAdd(variantId, 1).then(function () {
          btn.textContent = '✓ Pridané';
          btn.classList.add('added');
          setTimeout(function () { btn.textContent = 'Pridať do košíka'; btn.classList.remove('added'); }, 1800);
        }).catch(function (err) {
          window.VELOUR.showToast(err.message || 'Chyba pri pridávaní do košíka');
        });
      });
    });

    document.querySelectorAll('.set-add-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        var props = window.VELOUR.setContents(btn.dataset.contents);
        window.VELOUR.cartAdd(variantId, 1, props).then(function () {
          btn.textContent = '✓ Pridané';
          btn.classList.add('added');
          setTimeout(function () { btn.textContent = 'Pridať do košíka'; btn.classList.remove('added'); }, 1800);
        }).catch(function (err) {
          window.VELOUR.showToast(err.message || 'Chyba pri pridávaní do košíka');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    cards = Array.prototype.slice.call(document.querySelectorAll('#catalogGrid .product-card'));
    initFilterDropdowns();
    readUrl();
    applyFilters();
    initSizeSelectors();
    initCardLinks();
    initAddToCart();
    document.querySelectorAll('#catalogGrid .reveal, #setsGrid .reveal').forEach(function (el) { revealObserver.observe(el); });
  });
})();
